import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurgicalDiagnosisComponent } from './surgical-diagnosis.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TdoControlsModule } from 'src/app/tdo-controls/tdo-controls.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [SurgicalDiagnosisComponent],
  imports: [CommonModule,
    DirectivesModule,
    MatCheckboxModule,
    TdoControlsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule],
  exports: [SurgicalDiagnosisComponent]
})
export class SurgicalDiagnosisModule {} 